(function () {
  // --- CONFIGURATION ---
  const WAGYU_VARIANT_ID = 41589553823789;
  const DISCOUNTS = {
    WAGYU: 'FREE_WAGYU',
    OFF20: '20_OFF'
  };

  /**
   * 1. The Observer (Interception Logic)
   * This listens to all network traffic for /cart.js without making new requests.
   */
  
  // A. Intercept modern 'fetch' calls
  const originalFetch = window.fetch;
  window.fetch = function() {
    return originalFetch.apply(this, arguments).then(async (response) => {
      const url = typeof arguments[0] === 'string' ? arguments[0] : arguments[0].url;
      if (url && url.includes('/cart.js') && response.ok) {
        const clone = response.clone();
        clone.json().then(data => tryRunWinback(data));
      }
      return response;
    });
  };

  // B. Intercept older 'XMLHttpRequest' (AJAX) calls
  const open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function() {
    this.addEventListener('load', function() {
      if (this.responseURL.includes('/cart.js') && this.status === 200) {
        try {
          const data = JSON.parse(this.responseText);
          tryRunWinback(data);
        } catch (e) { console.error("Winback: Error parsing XHR cart", e); }
      }
    });
    return open.apply(this, arguments);
  };

  /**
   * 2. Dependency Management
   */
  function tryRunWinback(cartData) {
    const checkDeps = setInterval(() => {
      // Check for jQuery, your UI methods, and the confetti library
      if (window.jQuery && window.modalMini && window.stockmansteaks && typeof confetti === 'function') {
        clearInterval(checkDeps);
        initWinback(cartData).catch(console.error);
      }
    }, 100);
    
    // Safety: stop polling after 10 seconds if deps never load
    setTimeout(() => clearInterval(checkDeps), 10000);
  }

  /**
   * 3. Core Logic
   */
  async function initWinback(cart) {
    let winbackType = null;
    let shouldAddWagyu = false;

    // A. Inspect Discount Codes
    if (cart.discount_codes && cart.discount_codes.length > 0) {
      cart.discount_codes.forEach(discount => {
        if (discount.code.includes('WBFREEWAGYU-')) {
          winbackType = DISCOUNTS.WAGYU;
          shouldAddWagyu = true;
        } else if (discount.code.includes('WB20OFF-')) {
          winbackType = DISCOUNTS.OFF20;
        }
      });
    }

    // B. Handle Logic Cleanup
    if (!winbackType) {
      localStorage.removeItem(`WB_${DISCOUNTS.WAGYU}`);
      localStorage.removeItem(`WB_${DISCOUNTS.OFF20}`);
      return;
    }

    // C. Inspect Cart Items
    const wagyuItem = cart.items.find(item => 
      item.variant_id === WAGYU_VARIANT_ID && 
      item.properties && item.properties._FREE_WINBACK_ITEM === 'true'
    );

    // D. Action: Quantity Correction
    if (wagyuItem && wagyuItem.quantity > 1) {
      console.log('Winback: Reducing quantity to 1...');
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: wagyuItem.key, quantity: 1 })
      });
      window.location.reload();
      return;
    }

    // E. Action: Add Item or Show Modal
    const storageKey = `WB_${winbackType}`;
    const hasShownModal = localStorage.getItem(storageKey) === cart.token;

    if (shouldAddWagyu && !wagyuItem) {
      console.log('Winback: Adding free burger...');
      await window.stockmansteaks.addItem({
        variantId: WAGYU_VARIANT_ID,
        quantity: 1,
        ignoreAddonsModal: 1,
        properties: { _FREE_WINBACK_ITEM: 'true' }
      });

      localStorage.removeItem(`WB_${DISCOUNTS.WAGYU}`);
      window.location.reload(); 
    } else {
      if (!hasShownModal) {
        showModal(winbackType, storageKey, cart.token);
      }
    }
  }

  /**
   * 4. UI Logic
   */
  function showModal(type, storageKey, cartToken) {
    const $modal = $('#modal-winback');
    if (!$modal.length) return;

    // Update Text based on discount type
    const message = (type === DISCOUNTS.WAGYU) 
      ? `
        <p style="margin-bottom: 15px;">
          <img src="https://stockmansteaks.com.au/cdn/shop/products/p_4715048d-cdbf-48cb-8278-861501fefded.jpg?v=1678593760" alt="Wagyu Burger" style="display: block; margin: 0 auto; width: 150px; height: auto; border-radius: 10px;" />
        </p>
        <p>A <strong class="highlight">free 4-pack of Wagyu burgers</strong> has been added to your cart.</p>
      `
      : 
      `
        <p>
          <strong class="highlight" style="font-size: 32px;">$20 OFF</strong><br />
          <strong class="highlight">COUPON</strong> has been applied to your cart.
        </p>
      `;
    
    $modal.find('.modal-mini__body div').html(message);

    // Open Modal via Theme's existing Mini Modal logic
    if (window.modalMini) {
      window.modalMini.toggleModal($modal, true);

      // Confetti Animation
      if (typeof confetti === 'function') {
        confetti({
          particleCount: 300,
          spread: 200,
          origin: { y: 0.6 },
          colors: ['#d4af37', '#1a1a1a', '#ffffff', '#e02324'],
        });
      }

      // Mark as shown for this specific cart session
      localStorage.setItem(storageKey, cartToken);
    }
  }
})();